import { render, staticRenderFns } from "./EditPaymentMethod.vue?vue&type=template&id=7066ff84&scoped=true&"
import script from "./EditPaymentMethod.vue?vue&type=script&lang=ts&"
export * from "./EditPaymentMethod.vue?vue&type=script&lang=ts&"
import style0 from "./EditPaymentMethod.vue?vue&type=style&index=0&id=7066ff84&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7066ff84",
  null
  
)

export default component.exports